import { jsx as L } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ L(
  "path",
  {
    d: "M8.707 19.7071L18 10.4141L13.586 6.00006L4.293 15.2931C4.165 15.4211 4.074 15.5821 4.03 15.7571L3 21.0001L8.242 19.9701C8.418 19.9261 8.579 19.8351 8.707 19.7071ZM21 7.41406C21.781 6.63306 21.781 5.36706 21 4.58606L19.414 3.00006C18.633 2.21906 17.367 2.21906 16.586 3.00006L15 4.58606L19.414 9.00006L21 7.41406Z",
    fill: "currentColor"
  }
);
export {
  t as default
};
